import { themeGet } from '@styled-system/theme-get';
import styled, { css } from 'styled-components';

export const CaseInterna = styled.section`
  background: #e9ebed;
  .content {
    margin: 0 auto;
    max-width: 1000px;
    padding-bottom: 50px;
    padding-left: 5%;
    padding-right: 5%;
    a:not(.btn) {
      color: black;
      display: inline-block;
      font-weight: normal;
      position: relative;
      text-decoration: none;
      z-index: 9;
      u {
        text-decoration: none;
      }
      &:after {
        background: #364ef7;
        content: '';
        display: inline-block;
        height: 10px;
        left: 0;
        position: absolute;
        top: 60%;
        transition: 0.3s;
        width: 100%;
        z-index: -9;
      }
    }
    > img {
      display: block;
      height: auto;
      margin: 30px auto;
      max-width: 600px;
      width: 100%;
    }
    p {
      margin-bottom: 30px;
    }
    > h2 {
      color: #364ef7;
      font: bold 30px/40px 'Montserrat', sans-serif;
      letter-spacing: 0.5px;
      margin-bottom: 30px;
      text-align: center;
      i {
        display: block;
        font: 14px/24px 'Montserrat', sans-serif;
        text-align: center;
      }
    }
    > h3 {
      font: normal 18px/28px 'Montserrat', sans-serif;
      letter-spacing: 0.5px;
      margin-bottom: 30px;
      text-align: center;
    }
    blockquote {
      background: #263238;
      border-radius: 15px;
      color: white;
      margin-bottom: 30px;
      padding: 50px;
      text-align: center;
      p {
        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .btn {
      align-items: center;
      background-color: #0c29d0;
      border: 1px solid #0c29d0;
      border-radius: ${themeGet('olist.borderRadius.pill')};
      color: #ffffff;
      display: block;
      display: flex;
      height: 48px;
      margin: 0 auto 30px;
      margin-top: 32px;
      padding: 0px 24px;
      text-align: center;
      text-decoration: none;
      width: fit-content;
      &:hover {
        background-color: #0c29d0 !important;
        border: 1px solid #0c29d0 !important;
        box-shadow: none !important;
        color: #ffffff !important;
        svg {
          margin-left: 10px;
          width: 12px;
        }
      }
      svg {
        display: block;
        margin-left: 0px;
        overflow: hidden;
        transition: 0.3s;
        width: 0;
        path {
          fill: #ffffff !important;
        }
      }
      a {
        color: #ffffff;
        text-decoration: none;
      }
    }
  }
`;

export const Video = styled.div`
  height: 0;
  margin-bottom: 30px;
  padding-bottom: 56%;
  position: relative;
  width: 100%;
  iframe {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
`;

export const Banner = styled.div`
  &:nth-child(even) {
    > div {
      flex-direction: row-reverse;
      @include media('xs') {
        flex-direction: column;
      }
    }
  }
  > div {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 0;

    ${({ theme }) => {
      return (
        theme &&
        css`
          @media (max-width: ${theme.breakpoints.medium}) {
            flex-direction: column;
          }
        `
      );
    }}
  }
  .text {
    width: 45%;
    ${({ theme }) => {
      return (
        theme &&
        css`
          @media (max-width: ${theme.breakpoints.medium}) {
            width: 100%;
          }
        `
      );
    }}
    h1,
    h3,
    h4 {
      margin: calc(30px / 2) 0px;
    }
    p {
    }
    strong {
      color: $darkorange;
    }
  }
  .image {
    align-items: center;
    display: flex;
    height: auto;
    justify-content: center;
    padding-bottom: 0;
    position: relative;
    width: 50%;
    ${({ theme }) => {
      return (
        theme &&
        css`
          @media (max-width: ${theme.breakpoints.medium}) {
            width: 100%;
          }
        `
      );
    }}
    .img {
      background: transparent;
      border-radius: 40px;
      height: auto;
      margin: 0 auto;
      max-height: 500px;
      object-fit: cover;
      transform: none;
      width: 100%;
    }
  }
`;

export const Container = styled.div`
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1440px;
  padding: 0 80px;
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.medium}) {
          padding: 0 16px;
          flex-direction: column;
        }
      `
    );
  }}
`;
